export class FormValidation {
  constructor(validations = {}) {
    this.validations = validations;
    for (const key in validations) {
      this[key] = validations[key];
    }
  }

  test = (obj) => {
    if (!obj || typeof obj !== "object") {
      this.reset();
      return;
    }

    let invalidCount = 0;
    for (const key in this.validations) {
      const value = obj[key];
      this.validations[key].test(value) || invalidCount++;
    }

    return invalidCount === 0;
  }

  reset = () => {
    this._validations().forEach(v => v.reset());
  }

  getState = () => {
    if (this.hasError()) {
      return "error";
    } else if (this.passAllValidations()) {
      return "success";
    } else {
      return;
    }
  }

  hasError = () => {
    return this._validations().some(v => v.getState() === "error");
  }

  passAllValidations = () => {
    return this._validations().every(v => v.getState() === "success");
  }

  _validations() {
    return Object.keys(this.validations).map(k => this.validations[k]);
  }
}

export default FormValidation;


// WEBPACK FOOTER //
// ./src/models/FormValidation.js